import React, { useEffect, useRef } from 'react'
import useHoverContent from 'app/react/hooks/useHoverContent'
import { useFirstRender } from 'app/react/hooks/useFirstRender'

export default function Image (props) {

  const firstRender = useFirstRender()
  const videoElement = useRef(null)

  const { hoverClass, hoverContent, isPlaying } = useHoverContent({
    url: props.videoUrl || props.fullUrl
  })

  const imageClass = [
    hoverClass,
    'dm-images__image',
    `dm-images__image--object-fit-${props.fillClass}`,
    `dm-images__image--object-position-${props.positionClass}`
  ]

  const renderVideo = () => {
    if (!props.videoUrl) {
      return null
    }

    return (
      <video
        src={props.videoUrl}
        ref={videoElement}
        poster={props.url}
        controls={false}
      />
    )
  }

  useEffect(() => {
    if (firstRender) {
      return
    }

    isPlaying ?
      videoElement.current.play():
      videoElement.current.pause()

  }, [isPlaying])

  return (
    <div className={imageClass.join(' ')}>
      {props.videoUrl ?
        renderVideo():
        (<img src={props.url} alt={props.alt} />)
      }
      {hoverContent()}
    </div>
  )
}